module.exports = __webpack_public_path__ + "static/img/ckxz.50f32c42.png";